import { CONSTANTS } from '@pk/powerkioskutils';
import moment from 'moment-timezone';

export class ViewInvoice {
	public id: number;
	public invoiceNum: string;
	public supplierId: string;
	public supplierName: string;
	public serviceTypeId: string;
	public commodity: string;
	public totalAmount: number;
	public totalPaid: number;
	public totalRefunded: number;
	public noteCount: number;
	public addDate: Date;
	public sentDate: string;
	public dueDate: Date;
	public sender: string;
	public supplierEmail: string;
	public supplierCcEmail: string;
	public invoiceStatusId: number;
	public invoiceStatusName: string;
	public symbol: string;
	public rate: number;
	public brokerId: string;
	public claimReferenceNumber: string;

	constructor(viewInvoice?: ViewInvoice) {
		Object.assign(this, viewInvoice);

		this.addDate = this.addDate ? new Date(moment(this.addDate).format('MMM DD, YYYY hh:mm:ss a')) : this.addDate;
		this.dueDate = this.dueDate ? new Date(moment(this.dueDate).format('MMM DD, YYYY hh:mm:ss a')) : this.dueDate;
	}

	get isPaid() {
		return this.invoiceStatusId === CONSTANTS.invoiceStatuses.paid;
	}

	get netPaid(): number {
		return Math.round(((this.totalPaid ?? 0) - (this.totalRefunded ?? 0)) * 100) / 100;
	}

	get balance(): number {
		return Math.max(0, Math.round(((this.totalAmount ?? 0) - this.netPaid) * 100) / 100);
	}

	get canPay(): boolean {
		return (
			[CONSTANTS.invoiceStatuses.open, CONSTANTS.invoiceStatuses.sent, CONSTANTS.invoiceStatuses.failed].includes(this.invoiceStatusId) &&
			this.balance > 0
		);
	}
}
